import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

@Component({
    selector: "app-label",
    templateUrl: "./label.component.html",
    styleUrls: ["./label.component.scss"],
})
export class LabelComponent implements OnInit {
    @Input()
    text: string;
    @Input()
    color: string;
    @Input()
    showRemoveIcon = true;
    @Output()
    unassignLabel = new EventEmitter<void>();
    constructor() {}

    ngOnInit(): void {}
    unassign() {
        this.unassignLabel.next();
    }
}
